import { TopicDictationResult } from '../types';
import SentenceDiffResult from './SentenceDiffResult';

interface Props {
  result: TopicDictationResult;
}

export default function ResultPhase({ result }: Props) {
  const { averageCoverage, sentenceScores, recallRatio } = result;
  const coverageStatus = averageCoverage >= 80 ? 'success' : averageCoverage >= 50 ? 'warn' : 'danger';

  return (
    <div className="topic-recall-content">
      {/* 总览 */}
      <div className="topic-dictation-summary">
        <div className="topic-dictation-coverage-row">
          <span className="topic-dictation-coverage-value">{averageCoverage}%</span>
          <div className="topic-dictation-coverage-bar">
            <div
              className={`topic-dictation-coverage-fill ${coverageStatus}`}
              style={{ width: `${averageCoverage}%` }}
            />
          </div>
        </div>
        <div className="topic-recall-ratio">
          <span>自评想起 {Math.round(recallRatio * 100)}%</span>
          {averageCoverage >= 80 && <span className="pill success">建议 GOOD</span>}
          {averageCoverage >= 50 && averageCoverage < 80 && <span className="pill warn">建议 HARD</span>}
          {averageCoverage < 50 && <span className="pill danger">建议 AGAIN</span>}
        </div>
      </div>

      {/* 逐句结果 */}
      <div className="topic-dictation-results">
        {sentenceScores.map((score) => (
          <SentenceDiffResult key={score.index} score={score} />
        ))}
      </div>
    </div>
  );
}
